// Updated walkInForm.jsx with shared pricing calculations
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import VehicleSelectForm from './../../vehicleSelection';
import ServiceForm from './../../newServiceForm';
import NotesForm from './../../notesForm';
import DatesForm from './../../dateWalkForm';
import MobileAppointmentForm from './../../partial/MobileAppointmentForm';
import { isMobileLocation } from './../../../util/locationUtils';
import CustomerForm from './../../newCustomerForm';
import { HTTPService } from "./../../../services/httpService";
import { convertToUTC } from '../../../util/convert_timezone';
import dateService from '../../../services/dateService';
import LocationService from '../../../services/locationService';
// UPDATED: Import shared pricing module instead of old serviceUtils
import { 
  SharedRequestPricing, 
  SharedPricingUtils 
} from './../services/sharedPricingCalculations';
import ReactGA from 'react-ga4';
import _ from 'lodash';
import LocationSelector from '../../common/LocationSelector';
import { isMultiLocation } from '../../../util/locationUtils';
import { normalizeVin, isPlaceholderVin, findCreateBlockingForVin, extractRowsFrom409, buildOpenJobMessage } from '../../../util/duplicateDetection';
import { isAreaPriced, isMarineVehicleComplete, toVehiclePayload } from '../../../util/marineService';
import { isMarineDealerRow } from '../../../util/dealerAssetType';
import { isMarineVehicle, ASSET_TYPES } from '../../../util/assetType';
import { isAutoVehicleComplete } from '../../../util/vehicleCompleteness';
import { getRequestsByVin, saveDraft, updateDraft, deleteDraft, unlockDraft } from '../../../services/requestimatesService';
import DuplicateVinModal from '../../partial/DuplicateVinModal';
import SaveDraftModal from '../../partial/SaveDraftModal';

const API = new HTTPService();

class WalkinForm extends Component {

  constructor(props) {

    super(props);

    // Get referral data immediately for initial state
  const referralData = this.props.location?.state?.referralData;
  const duplicateData = this.props.location?.state?.duplicateData;

    // Guard 2: acknowledgement + stashed submit arg for the re-invoked submit.
    this._dupAcknowledged = false;
    this._dupCreateAppointment = false;

    // Guard 3: a ledger of what this submit has ALREADY committed.
    //
    // handleSubmit is an 8-call non-atomic sequence. A failure in one of the
    // late calls (offer / schedule / calendar-book) used to abort with
    // "Error creating job" while the request, its states, its note and its
    // service lines were already in the database. Re-submitting re-ran the
    // whole sequence from the top, and because the server collapses a repeat
    // POST /requestimates/ inside 2 minutes and returns the EXISTING id
    // (docs/DATA_CONVENTIONS.md §1.1 — "a 200 with a bare number means
    // collapsed, not created"), every retry appended another full set of
    // service lines to the same job. Four attempts produced one job carrying
    // four copies of every service, at four times the price and duration.
    //
    // The ledger makes a retry RESUME at the failed call instead of recreating
    // everything before it. Nothing here is cleared on failure — that is the
    // point.
    this._committed = this.freshCommitLedger();

    const base = {
      redirect: false,
      currentStep: 1,
      showDupModal: false,
      dupMatches: [],
      customer: duplicateData?.customer || referralData?.customer || "",
      customerName: duplicateData?.customerName || referralData?.customerName || "",
      customerEmail: duplicateData?.customerEmail || referralData?.customerEmail || "",
      customerType: duplicateData?.customerType || (referralData ? "retail" : ""),
      vehicle: duplicateData?.vehicle || referralData?.vehicle || '',
      duplicateRequestId: duplicateData?.requestId || null,
      services: [],
      total : 0,
      discount : 0,  // UPDATED: Now properly tracks discounts
      fee : 0,
      loading:false,
      notes:"",
      taxRate : 0,
      taxPercent : 0,
      availableDate: new moment().startOf('day'),
      dueDate: new moment().startOf('day'),
      appointmentStart: null,  // mobile-only: single appointment datetime
      newVehicleId: {},
      newRequestId: {},
      user: this.props.user,
      excludeDays : [],
      dealerships : [],
      authenticated : 0,
      serviceHint: referralData?.requestedService || null,
      referralId: referralData?.referralId || null,
      referralLocationId: referralData?.locationId || null,
      sendEstimate: false, // Send estimate PDF to customer
      formLocationId: this.props.selectedLocationId || (this.props.locations?.length === 1 ? this.props.locations[0].location_id : null),
      // Draft support: draftId is set when resuming a parked draft (via DraftResume).
      draftId: this.props.draftId || null,
      showSaveDraftModal: false,
      savingDraft: false
    };

    // Resuming a parked draft: seed the wizard from the snapshot and jump to the
    // step the user left off at.
    this.state = this.props.initialDraft
      ? { ...base, ...this.draftOverrides(this.props.initialDraft) }
      : base;

    this.handleChange = this.handleChange.bind(this);
    this.handleServices = this.handleServices.bind(this);
    this.handleCustomer = this.handleCustomer.bind(this);
    this.handleVIN = this.handleVIN.bind(this);
    this.handleNotes = this.handleNotes.bind(this);
    this.handleDueDate = this.handleDueDate.bind(this);
    this.handleAvailableDate = this.handleAvailableDate.bind(this);
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
this.handleStockNumberChange = this.handleStockNumberChange.bind(this);
this.handleDealNumberChange = this.handleDealNumberChange.bind(this);
  }

  async componentDidMount() {

    let installerRequest = "/installerLocations/"+this.props.typeId;        
    const  { data : installer }  =  await API.get(installerRequest);
   
    const firstOne = installer.shift();
    this.setState({ installer : firstOne });
//    //console.log("Installer : ",this.state.installer);
    if (firstOne && firstOne.stripe_tax_rate) {
      let taxRequest = "/taxes/"+firstOne.stripe_tax_rate;
      const  { data : taxRate }  =  await API.get(taxRequest);
      this.setState({ taxPercent : taxRate.percentage });
    } else {
      console.error(
        `[walkInForm] Missing stripe_tax_rate for installer ${this.props.typeId}`,
        `location_id=${firstOne && (firstOne.location_id || firstOne.Location_id)}.`,
        `Tax rate must be configured on installer_locations — defaulting to 0% is NOT correct.`
      );
    }
      //read the installer calendar to manage the bookings
  
      const locParam = this.props.selectedLocationId && this.props.selectedLocationId !== 'all'
        ? `?locationId=${this.props.selectedLocationId}` : '';
      let calendarRequest = `/dealerCalendars/${this.props.typeId}${locParam}`;

      const  { data : dealerCalendarDays }  = await API.get(calendarRequest);

      calendarRequest = `/installerCalendars/${this.props.typeId}${locParam}`;

      const  { data : installerCalendarDays }  = await API.get(calendarRequest);
    
      var calendarList = dealerCalendarDays.concat(installerCalendarDays);
    
      var calendarDays = _.orderBy(calendarList, ['workDate'],['asc']);
      this.setState({ calendarDays });
    
      // Create the array of the booked calendar services in the upcoming 60 days

      if (calendarDays.length > 0){
        const startDate = moment.utc().format("YYYY-MM-DD");

//           //console.log("CC - start Date", startDate);
        var totalDuration = 60;

        // caalendarInWindow
        var bookedArray = calendarDays.filter(day => moment.utc(day.workDate).diff(startDate) >= 0);

//         //console.log( "Upcoming calendar : ", bookedArray);
//         //console.log("CC - start Date", startDate);
//         //console.log("Installer :", this.state.installer);

        //capacityCalendar
        var bookedData = new Array(totalDuration);

        for (var m=0; m < totalDuration; m++) {
          bookedData[m] = {'x' : m, 'exDate' : moment.utc(startDate).add(m,"days").format("YYYY-MM-DD") ,'y' : 0};
      };

      // Need to build the array of booked capacity here for the next 60 days
      for (let k=0; k < bookedData.length; k++ ){
        // for every day in the calendar days, add up the daily_work and assign it to the right day
        let matchingWork = bookedArray.filter(work => moment.utc(work.workDate).format("YYYY-MM-DD") === bookedData[k].exDate);
        let dayTotal = matchingWork.reduce( function (result, value) {
          return result + value.capacity
        } , 0)
        bookedData[k].y = dayTotal;
      };

      let exclude = [];
//       //console.log ("Booked data length :", bookedData.length)
      for (let b=0; b< bookedData.length; b++){
        // this should be the capacity of the installer vs the size of job
        if (bookedData[b].y >= this.state.installer.capacity * 2){
//           //console.log ("Exclude :", new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
          exclude.push(new Date(moment(bookedData[b].exDate).format("MMMM D, YYYY")));
        }
    }
    
          this.setState( { excludeDays : exclude, bookedDays : bookedData});
    //      //console.log("Booked Array :", bookedData);
    //      //console.log("Excluded dates :", exclude)    
          };
    // Read dealerships scoped to this installer + location + radius. The
    // server falls back to legacy installer-only behaviour if locationId is
    // omitted (e.g., multi-location installer with "all" selected).
          const dealerLocId = this.state.formLocationId || this.props.selectedLocationId;
          const dealerParams = new URLSearchParams();
          if (dealerLocId && dealerLocId !== 'all') {
            dealerParams.set('locationId', dealerLocId);
            dealerParams.set('radius_miles', '50');
          }
          const dealerQs = dealerParams.toString() ? `?${dealerParams.toString()}` : '';
          const dealerRequest = `/dealerInstall/${this.props.typeId}${dealerQs}`;
          const  { data : dealerships }  =  await API.get(dealerRequest);
          // Only active dealerships are billable — never surface inactive ones in the
          // picker, to avoid creating invoices against a closed/incorrect dealership.
          const activeDealerships = (dealerships || []).filter(
            d => d.is_active !== false && d.is_active !== 0 && d.is_active !== '0'
          );
          this.setState({ dealerships: activeDealerships });

      // Fetch operating hours for the selected location (for scheduling timestamps)
      const locationId = this.state.formLocationId || this.props.selectedLocationId;
      if (locationId && locationId !== 'all') {
        try {
          const hoursData = await LocationService.getOperatingHours(locationId);
          this.setState({ operatingHours: hoursData.hours || hoursData });
        } catch (err) {
          console.log('Could not fetch operating hours, using defaults');
        }
      }

      //check if authenticated
      await this.readAuth(this.props.typeId);
      // Referral data is already set in constructor, just log for confirmation
      const referralData = this.props.location?.state?.referralData;
      if (referralData) {
        console.log("Referral data processed in componentDidMount:", {
          customer: this.state.customer,
          customerName: this.state.customerName,
          customerEmail: this.state.customerEmail,
          vehicle: this.state.vehicle,
          referralId: this.state.referralId
        });
      }

      // Duplicate/Rebook flow: customer is pre-filled, advance to vehicle step
      // VehicleSelectForm will auto-decode the VIN, then handleVIN will advance to step 3
      const duplicateData = this.props.location?.state?.duplicateData;
      if (duplicateData) {
        console.log("Duplicate/Rebook data processed:", {
          customer: this.state.customer,
          customerName: this.state.customerName,
          vehicle: this.state.vehicle,
          duplicateRequestId: this.state.duplicateRequestId
        });
        // Use functional setState to avoid overwriting if VIN decode already advanced past step 2
        // Also create a new vehicle reference to trigger VehicleSelectForm.componentDidUpdate
        this.setState(prevState => ({
          currentStep: Math.max(prevState.currentStep, 2),
          vehicle: { ...prevState.vehicle }
        }));
      }
  };

checkVehicleComplete = () => {
    const vehicle = this.state.vehicle;
    if (!vehicle) return false;

    // A boat has no trim, body or id_car_trim — the marine catalog is keyed on
    // assetType + vehicle_size 'SF', not on car body style — so the automotive
    // gate below would block Next forever.
    // Tolerates every asset_type spelling in play — 'boat' (what the vehicle
    // column stores), 'marine' (what this client used to send), and the BT VIN.
    if (isMarineVehicle(vehicle)) {
      return isMarineVehicleComplete(vehicle);
    }

    // Every catalog-relevant field must be set. Shared with requestimateForm via
    // isAutoVehicleComplete so the two forms cannot drift — and because a bare
    // truthiness check passes a DESELECTED dropdown, whose value is the
    // placeholder string ('Trim', 'Style') rather than empty.
    return isAutoVehicleComplete(vehicle);
};

// Guard 2: user confirmed they want to create despite the open same-VIN job.
handleDupConfirm = () => {
  this._dupAcknowledged = true;
  const createAppointment = this._dupCreateAppointment;
  this.setState({ showDupModal: false, dupMatches: [] }, () => {
    this.handleSubmit({ preventDefault: () => {} }, createAppointment);
  });
};

handleDupCancel = () => {
  this._dupAcknowledged = false;
  this.setState({ showDupModal: false, dupMatches: [], loading: false });
};

// A fresh ledger — nothing committed yet. See the constructor for why this exists.
freshCommitLedger = () => ({
  vehicle: false,
  requestId: null,
  states: false,
  note: false,
  services: false,
  offer: false,
  calendar: false,
  booked: false,
  // Side effects that leave the building. These record as ATTEMPTED, not as
  // succeeded: all four swallow their own errors, so we cannot tell a failure
  // from a success whose response was lost — and a second Google Calendar event
  // or a second email to the customer is worse than a missing one. When a quote
  // email fails the user is already told to resend it from the request page.
  referral: false,
  googleCalendar: false,
  bookingEmail: false,
  quoteEmail: false,
  fingerprint: null,
});

// Identifies WHAT was committed, so a resume can tell "the same job, finish it"
// from "the user went back and changed the job". Resuming the second silently
// would drop their edit — the request row and its service lines are already
// written with the old values.
submitFingerprint = () => JSON.stringify({
  vin: normalizeVin(this.state.vehicle && this.state.vehicle.vin),
  customer: this.state.customer,
  date: dateService.toAPIDate(this.state.availableDate),
  services: (this.state.services || []).map(s =>
    [s.service_id, s.service_amount, s.service_discount, s.quantity].join(':')
  ),
});

handleSubmit = async (e, createAppointment = false) => {
  e.preventDefault();
  // Guard 1: block re-entrant submits (rapid double-click / Enter).
  if (this.state.loading) return;
  this.setState({ loading: true });

  // Guard 3: what a previous attempt already wrote. Empty on a first submit.
  const done = this._committed;

  try {
    console.log("Starting job creation with services:", this.state.services);
    console.log("Create appointment:", createAppointment);
    if (done.requestId) {
      console.log("Resuming a part-built job — request already created:", done.requestId, done);
      if (this.submitFingerprint() !== done.fingerprint) {
        this.setState({ loading: false });
        alert(
          `Job #${done.requestId} was already created from this form, so these changes ` +
          `can't be applied here.\n\nOpen job #${done.requestId} from your list to edit it.`
        );
        return;
      }
    }

    // Validate services before proceeding
    const validationResult = SharedPricingUtils.validatePricingData(this.state.services);
    if (!validationResult.isValid) {
      throw new Error(`Pricing validation failed: ${validationResult.errors.join(', ')}`);
    }

    // Guard 2: warn if this VIN already has a job the server's DUP-GUARD would
    // reject. Fail-open — never block creation if the lookup itself errors.
    // Skipped once the request exists: the only open job on this VIN would be
    // the one we are in the middle of finishing, and warning about it would
    // send the user round the "create anyway" loop that duplicates the job.
    const dupVin = normalizeVin(this.state.vehicle && this.state.vehicle.vin);
    if (!done.requestId && !this._dupAcknowledged && !isPlaceholderVin(dupVin)) {
      try {
        const rows = await getRequestsByVin(this.props.typeId, dupVin);
        const dups = findCreateBlockingForVin(rows);
        if (dups.length) {
          this._dupCreateAppointment = createAppointment;
          this.setState({ loading: false, showDupModal: true, dupMatches: dups });
          return;
        }
      } catch (dupErr) {
        console.warn("VIN duplicate check failed, proceeding with create:", dupErr);
      }
    }

    // Determine job type and tax configuration
    const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
    const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;

    // Get complete pricing breakdown using shared module
    const pricingBreakdown = SharedRequestPricing.getCompletePricingBreakdown(this.state.services, {
      jobType: jobType,
      taxRate: taxRate
    });

    console.log("Pricing breakdown for installer job:", pricingBreakdown);

    // STEP 1: Complete ALL Jobvious database work first
    console.log("Starting job creation process...");

    // Each step records itself in the ledger the moment it succeeds, so a
    // failure further down never replays it.

    // Add vehicle if needed
    if (!this.state.vehicle.id && !done.vehicle) {
      console.log("Adding vehicle...");
      await this.addVehicle();
      done.vehicle = true;
    }

    // Add the main request with calculated pricing
    let newRequest = done.requestId;
    if (!newRequest) {
      console.log("Adding request...");
      newRequest = await this.addRequest(pricingBreakdown, createAppointment);
      done.requestId = newRequest;
      done.fingerprint = this.submitFingerprint();
    } else {
      // Resuming: addRequest is what seeds state.newRequestId, and the later
      // steps read it off state.
      this.setState({ newRequestId: newRequest });
    }

    if (!done.states) {
      // Always add "created" as the first state for consistency
      console.log("Adding request state... created");
      await this.addRequestState(newRequest, "created", null);

      // If booking appointment or wholesale, also add "scheduled" state
      if (this.state.customerType === "whole" || createAppointment) {
        console.log("Adding request state... scheduled");
        await this.addRequestState(newRequest, "scheduled", null);
      }
      done.states = true;
    }

    // Add note (FIX: Added missing await)
    if (!done.note) {
      console.log("Adding note...");
      await this.addNote(newRequest);
      done.note = true;
    }

    // Add services with calculated pricing
    if (!done.services) {
      console.log("Adding services...");
      await this.addServices(newRequest, pricingBreakdown);
      done.services = true;
    }

    // Add request offered
    if (!done.offer) {
      console.log("Adding request offered...");
      await this.addOffer(createAppointment, pricingBreakdown.totalDuration);
      done.offer = true;
    }

    // Add Jobvious calendar entries (created as "draft" by POST /schedule)
    if (!done.calendar) {
      console.log("Adding to Jobvious calendar...");
      await this.addCalendar();
      done.calendar = true;
    }

    // If booking appointment or wholesale, flip calendar entries from "draft" to "booked"
    if ((this.state.customerType === "whole" || createAppointment) && !done.booked) {
      console.log("Flipping calendar entries to booked...");
      await this.bookCalendarEntries();
      done.booked = true;
    }

    console.log("✅ Core job creation completed successfully");

    // STEP 2: Update referral status if this came from a referral
    if (this.state.referralId && !done.referral) {
      console.log("Updating referral status for referral ID:", this.state.referralId);
      try {
        await this.updateReferralStatus(this.state.referralId, newRequest);
        console.log("✅ Referral status updated to ESTIMATE_CREATED");
      } catch (referralError) {
        console.error("Failed to update referral status:", referralError);
        // Don't fail the entire flow
      }
      done.referral = true;
    }

    // STEP 3: Attempt Google Calendar sync as silent bonus feature
    if ((this.state.customerType === "whole" || createAppointment) && this.state.authenticated && !done.googleCalendar) {
      console.log("Attempting Google Calendar sync...");
      try {
        await this.addAppointmentSilently(newRequest);
        console.log("✅ Google Calendar sync completed as bonus");
      } catch (calendarError) {
        console.log("Google Calendar sync skipped (optional feature):", calendarError.message);
        // Completely silent - no user notification for calendar failures
      }
      // Attempted — never retried on a resume. PUT /addAppt/ inserts a new
      // Google event every time; a resume would leave the job double-booked on
      // the shop's real calendar.
      done.googleCalendar = true;
    }

    // STEP 4: Send email notification if creating appointment for retail
    if (createAppointment && this.state.customerType !== "whole" && !done.bookingEmail) {
      console.log("Sending booking confirmation email...");
      try {
        await this.sendEmail(newRequest);
        console.log("✅ Booking email sent");
      } catch (emailError) {
        console.log("Email notification skipped:", emailError.message);
        // Silent - don't fail the flow
      }
      done.bookingEmail = true;
    }

    // STEP 4b: Send estimate to customer if checkbox checked
    if (this.state.sendEstimate && !done.quoteEmail) {
      console.log("Sending estimate to customer...");
      try {
        await API.post(`/requests/${newRequest}/send-quote`);
        // Add request state record for estimate sent
        await this.addRequestState(newRequest, "estimate_sent", null);
        console.log("✅ Estimate sent to customer");
      } catch (quoteError) {
        console.error("Failed to send estimate:", quoteError);
        // Don't fail the flow, but notify user
        alert("Estimate created but email failed to send. You can resend from the request detail page.");
      }
      done.quoteEmail = true;
    }

    // STEP 5: Complete workflow based on job type
    //
    // `loading` deliberately STAYS true from here to the redirect. It used to be
    // cleared on this line, which re-enabled the Create button before a blocking
    // alert() and a full-page window.location reload — so the finished form sat
    // on screen, interactive, for the whole bundle load. A user who pressed
    // Create again in that window ran a second, successful create against the
    // same form session: that is how a job with no error at all picked up a
    // second set of service and offer rows. Nothing after this point needs the
    // button back; we are leaving the page.

    // Resumed from a draft → clear the parked draft now that it's a real request.
    if (this.state.draftId) {
      try { await deleteDraft(this.state.draftId); }
      catch (cleanupErr) { console.warn("draft cleanup failed:", cleanupErr); }
    }

    if (this.state.customerType !== "whole") {
      if (createAppointment) {
        alert("Job booked successfully! Appointment created and confirmation email sent.");
        ReactGA.event({category: 'Installer', action: 'Created and Booked Estimate', label: 'prod'});
        window.location = "/jobs?filter=scheduled";  // Redirect to scheduled jobs when appointment is booked
      } else {
        const message = this.state.sendEstimate
          ? "Estimate created and sent to customer!"
          : "Adding the estimate to your list";
        alert(message);
        ReactGA.event({category: 'Installer', action: 'Created Estimate', label: 'prod'});
        window.location = "/requestimates";  // Redirect to estimates when just creating estimate
      }
    } else {
      alert("Adding this dealer work to your calendar");
      window.location = "/jobs?filter=scheduled";  // Redirect to scheduled jobs for dealer work
      ReactGA.event({category: 'Installer', action: 'Created Job', label: 'prod'});
    }

  } catch (error) {
    console.error('❌ Error creating job:', error);
    this._dupAcknowledged = false;
    this.setState({ loading: false });
    if (error.response?.status === 409) {
      // Duplicate open job — describe the existing request instead of a bare 409.
      // Prefer rows from the 409 body; fall back to the VIN lookup (fail-open).
      let rows = extractRowsFrom409(error.response.data);
      if (!rows.length) {
        try {
          const vin = normalizeVin(this.state.vehicle && this.state.vehicle.vin);
          if (!isPlaceholderVin(vin)) {
            rows = findCreateBlockingForVin(await getRequestsByVin(this.props.typeId, vin));
          }
        } catch (lookupErr) {
          console.warn('409 duplicate lookup failed:', lookupErr);
        }
      }
      alert(buildOpenJobMessage(this.state.vehicle, rows));
    } else if (this._committed.requestId) {
      // The job EXISTS — only a later step failed. Saying "error creating job"
      // here is what sent people back round the wizard to create it again.
      // Retrying from this dialog now resumes at the failed step (Guard 3).
      const stage = !this._committed.services ? 'saving its services'
        : !this._committed.offer ? 'scheduling it'
        : !this._committed.calendar ? 'adding it to the calendar'
        : 'confirming its calendar booking';
      alert(
        `Job #${this._committed.requestId} was created, but we hit a problem ${stage}.\n\n` +
        `${error.message}\n\n` +
        `Press Create again to finish it — this will NOT create a second job. ` +
        `If it keeps failing, the job is safe in your list; open it to schedule it.`
      );
    } else {
      alert('Error creating job: ' + error.message);
    }
  }
};

// ADD this new silent calendar sync method (same pattern as requestimates.jsx):
addAppointmentSilently = async (requestId) => {
  try {
    console.log("Silent calendar sync starting for request:", requestId);
    
    // Use the same server endpoints as the working requestimates.jsx code
    let readAppt = `/readAppt/${requestId}`;
    const { data: appt } = await API.get(readAppt);

    if (!appt || appt.length === 0) {
      throw new Error('No appointment data found for calendar sync');
    }

    let newAppt = {
      request: requestId,
      summary: `${appt[0].Year} ${appt[0].Make} ${appt[0].Model}`,
      description: `Customer: ${this.state.customerName || 'Dealer Job'}`,
      calendar: appt[0].calendar_id,
      startDate: appt[0].work_date,
      duration: appt[0].request_duration,
      installerId: this.props.typeId,
    };

    console.log("Sending to Google Calendar:", newAppt);
    
    let apptAdd = `/addAppt/`;
    const response = await API.put(apptAdd, newAppt);
    
    console.log("Google Calendar response:", response.data);
    return response.data;
    
  } catch (error) {
    // Silent failure - just log, don't throw
    console.log('Silent Google Calendar sync failed:', error.message);
    return null;
  }
};

// Add this method to WalkInForm
updateReferralStatus = async (referralId, requestId) => {
  // Handle case where requestId might be an object or just the ID
  const actualRequestId = typeof requestId === 'object'
    ? (requestId.request_id || requestId.requestId || requestId.id || requestId)
    : requestId;

  console.log("updateReferralStatus called with:", {
    referralId,
    requestIdParam: requestId,
    actualRequestId
  });

  const updateData = {
    referralId: referralId,
    status: 'ESTIMATE_CREATED',
    request_id: actualRequestId  // Link the referral to the created request
  };

  console.log("Sending referral update:", updateData);
  const response = await API.put('/referrals', updateData);
  console.log("Referral update response:", response.data);
  return response.data;
};

// Send booking confirmation email to customer
sendEmail = async (request) => {
  console.log("📧 FRONTEND: Initiating booking email send for request:", request);
  console.time(`📧 Frontend Email Send - ${request}`);

  try {
    const response = await API.get(`/sendemailb/${request}`);
    console.timeEnd(`📧 Frontend Email Send - ${request}`);

    console.log("📧 FRONTEND: Email API response:", response.data);

    if (response.data && response.data.success) {
      console.log("✅ FRONTEND: Booking email sent successfully for request:", request);
      return true;
    } else if (response.status === 200 && !response.data.success) {
      // Handle legacy success response (HTTP 200 but no JSON success flag)
      console.log("✅ FRONTEND: Booking email sent (legacy response) for request:", request);
      return true;
    } else {
      console.error("❌ FRONTEND: Failed to send booking email:", {
        request,
        response: response.data
      });
      return false;
    }
  } catch (error) {
    console.error("❌ FRONTEND: Error sending booking email:", error);
    return false;
  }
};
  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }
handleStockNumberChange(stockNumber) {
  // No-op - fields won't show for installers anyway
}

handleDealNumberChange(dealNumber) {
  // No-op - fields won't show for installers anyway  
}
  handleCancel = e => {
    e.preventDefault();
    // Offer to save a draft once there's meaningful work (vehicle tab or beyond);
    // otherwise discard as before.
    if (this.isDraftWorthy()) {
      this.setState({ showSaveDraftModal: true });
      return;
    }
    if (this.state.draftId) unlockDraft(this.state.draftId);
    ReactGA.event({category: 'Installer', action: 'Cancel Estimate', label: 'prod'});
    this.props.history.push("/requestimates");
    return;
  }

  // ---- Draft support ----------------------------------------------------------

  // Only worth prompting to save once the user has entered vehicle-tab data or
  // progressed past it. Bailing on the customer step just discards.
  isDraftWorthy() {
    return this.state.currentStep >= 2 &&
      (!!this.state.vehicle || this.state.services.length > 0);
  }

  // State overrides applied when resuming a draft (dates back to moment objects).
  draftOverrides(d) {
    return {
      currentStep: this.props.resumeStep || d.currentStep || 1,
      customer: d.customer || "",
      customerName: d.customerName || "",
      customerEmail: d.customerEmail || "",
      customerType: d.customerType || "",
      services: d.services || [],
      total: d.total || 0,
      discount: d.discount || 0,
      fee: d.fee || 0,
      taxRate: d.taxRate || 0,
      taxPercent: d.taxPercent || 0,
      notes: d.notes || "",
      availableDate: d.availableDate ? moment(d.availableDate) : new moment().startOf('day'),
      dueDate: d.dueDate ? moment(d.dueDate) : new moment().startOf('day'),
      appointmentStart: d.appointmentStart ? moment(d.appointmentStart) : null,
      sendEstimate: d.sendEstimate || false,
      referralId: d.referralId || null,
      referralLocationId: d.referralLocationId || null,
      serviceHint: d.serviceHint || null,
      formLocationId: d.formLocationId || null,
      vehicle: d.vehicle || ''
    };
  }

  // The full wizard-state snapshot stored as draft_payload.
  buildDraftPayload() {
    const s = this.state;
    return {
      wizardType: "installer",
      currentStep: s.currentStep,
      customer: s.customer,
      customerName: s.customerName,
      customerEmail: s.customerEmail,
      customerType: s.customerType,
      vehicle: s.vehicle || null,
      services: s.services,
      total: s.total, discount: s.discount, fee: s.fee,
      taxRate: s.taxRate, taxPercent: s.taxPercent,
      notes: s.notes,
      availableDate: s.availableDate ? moment(s.availableDate).format("YYYY-MM-DD HH:mm:ss") : null,
      dueDate: s.dueDate ? moment(s.dueDate).format("YYYY-MM-DD HH:mm:ss") : null,
      appointmentStart: s.appointmentStart ? moment(s.appointmentStart).format("YYYY-MM-DD HH:mm:ss") : null,
      sendEstimate: s.sendEstimate,
      referralId: s.referralId,
      referralLocationId: s.referralLocationId,
      serviceHint: s.serviceHint,
      formLocationId: s.formLocationId,
      vin: s.vehicle ? s.vehicle.vin : null,
      serviceRequested: s.services.length
        ? (s.services[0].service_category + " - " + s.services[0].description)
        : null,
      requestor: s.customer,
      assignedTo: this.props.typeId,
      location_id: s.formLocationId || this.props.selectedLocationId || null
    };
  }

  // POST/PUT body: the snapshot (draft_payload) + the real request columns.
  // We mirror addRequest's field set so the draft row is a VALID, recreatable
  // request (NOT NULL columns like request_type must be present) and so the list
  // and Phase-2 VIN discovery read real values. Values may be partial at draft
  // time. Wholesale walk-ins are recorded as requestType "dealer" (see addRequest).
  buildDraftBody() {
    const s = this.state;
    const p = this.buildDraftPayload();
    const requestType = s.customerType === "whole" ? "dealer" : this.props.userType;
    return {
      // draft bookkeeping
      draft_payload: p,
      draft_step: p.currentStep,
      draft_owner_id: this.props.user && this.props.user.User_id,
      // request columns (mirror addRequest)
      requestType,
      requestor: s.customer,
      serviceRequested: p.serviceRequested,
      requestTotal: s.total || 0,
      requestDiscount: s.discount || 0,
      requestFee: s.fee || 0,
      requestDuration: 0,
      requestTaxes: 0,
      assignedTo: this.props.typeId,
      createdBy: this.props.typeId,
      availableDate: p.availableDate,
      dueDate: p.dueDate,
      appointment_start: p.appointmentStart || null,
      vin: p.vin,
      createdType: "installer",
      installerCatalog: this.props.typeId,
      location_id: p.location_id
    };
  }

  handleSaveDraft = async () => {
    if (this.state.savingDraft) return;
    this.setState({ savingDraft: true });
    try {
      const body = this.buildDraftBody();
      if (this.state.draftId) {
        await updateDraft(this.state.draftId, body);
        unlockDraft(this.state.draftId);
      } else {
        await saveDraft(body);
      }
      ReactGA.event({category: 'Installer', action: 'Saved Request Draft', label: 'prod'});
      this.props.history.push("/requestimates");
    } catch (err) {
      console.error("Error saving draft:", err);
      this.setState({ savingDraft: false });
      alert("Sorry — we couldn't save this draft. " + (err.message || ""));
    }
  };

  handleDiscardDraft = () => {
    if (this.state.draftId) unlockDraft(this.state.draftId);
    ReactGA.event({category: 'Installer', action: 'Discarded Request Draft', label: 'prod'});
    this.props.history.push("/requestimates");
  };

  handleKeepEditing = () => this.setState({ showSaveDraftModal: false });

  handleNotes(notes) {
    this.setState({notes})
  }

// UPDATED: Use shared pricing calculations
handleServices(services, total, discount) {
  console.log("handleServices called with:", { services, total, discount });
  
  // Validate the totals using shared pricing module
  const calculatedTotal = SharedRequestPricing.calculateRequestTotal(services);
  const calculatedDiscount = SharedRequestPricing.calculateRequestDiscount(services);
  
  // Log comparison for debugging
  if (Math.abs(total - calculatedTotal) > 0.01 || Math.abs(discount - calculatedDiscount) > 0.01) {
    console.warn("Total mismatch detected:", {
      passedTotal: total,
      calculatedTotal: calculatedTotal,
      passedDiscount: discount,
      calculatedDiscount: calculatedDiscount
    });
  }
  
  // Use calculated values for consistency
  this.setState({
    services, 
    total: calculatedTotal,      // Use shared calculation
    discount: calculatedDiscount // Use shared calculation
  });
}

  handleCustomer(customer, customerName, customerType, customerRow) {
    this.setState({customer, customerName, customerType, customerRow});
  }
    
// In WalkInForm - Enhanced handleVIN method
handleVIN(vehicle) {
    console.log("Update vehicle state", vehicle);
    this.setState({ vehicle }, () => {
        // Auto-advance if this is a referral or duplicate AND vehicle is FULLY complete
        if ((this.state.referralId || this.state.duplicateRequestId) && this.checkVehicleComplete()) {
            // Add a small delay to ensure all UI updates are complete
            setTimeout(() => {
                if (this.checkVehicleComplete()) { // Double-check after delay
                    console.log("Vehicle fully populated - auto-advancing to step 3");
                    this.setState({ currentStep: 3 });
                }
            }, 500);
        }
    });
}
// Separate method to check vehicle completion
handleDueDate(date) {
    this.setState({ dueDate: date })
  }

  handleAvailableDate(date) {
    this.setState({availableDate: date})
  }

  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;
    const  { data : installer }  =  await API.get(installerRequest);
  //  //console.log("Installer :", installer);
    this.setState( {authenticated : installer[0].authenticated, auth : installer[0]});
  }

  addRequestState = async (requestId, requeststate, requestService) => {
    const state = {
      requestId: requestId,
      stateDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      requestStatus: requeststate,
      serviceId: requestService,
      changedByUserId: this.props.user.User_id,
      changedByUserType: this.props.userType
    };

    const apiEndpoint = `/requestState`;
    await API.post(apiEndpoint, state);
    return null;
  };

  // create a jumbo object of requestimate and vehicle and send it to a service
  addVehicle = async () => {
    const { vehicle } = this.state;
    // Marine attributes must reach the server FLAT. It reads them off the top
    // level and never descends into a nested object, so a nested payload writes
    // a boat with no marine record and still returns 200. Services ride along so
    // a freeboard entered in the area calculator is learned onto the reference
    // row — the only place that value is ever captured.
    const { data } = await API.post(`/vehicles`, toVehiclePayload(vehicle, this.state.services));
    // This endpoint returns HTTP 200 on failure, with { error: true, message }
    // in the body — the status code is never a reliable signal. Without this
    // check a boat that was never created lets the estimate proceed as though
    // it exists.
    if (data && data.error) {
      throw new Error(data.message || 'Failed to add vehicle.');
    }
    return null;
  };

  addCalendar = async () => {
    let calendar = {
      requestId: this.state.newRequestId,
      installerId : this.props.typeId,
      installerCapacity : this.props.capacity,
      startDate : convertToUTC(this.state.availableDate).format("MM-DD-YYYY"),
      // Mobile bookings carry an appointment_start (date + time). ISO-8601
      // UTC with Z marker per server's UTC-everywhere policy.
      appointment_start: this.state.appointmentStart
        ? moment(this.state.appointmentStart).toISOString()
        : null,
      location_id: this.state.formLocationId || 0
    }
    // take the work requested and create the draft calendar entries
    const { data : newCalendar } = await API.post(`/schedule/`, calendar)

    return newCalendar;
    }

    bookCalendarEntries = async () => {
      const calendarEntry = {
        requestId: this.state.newRequestId,
        installerId: this.props.typeId,
        serviceId: null,
        workStatus: "booked",
        workDate: convertToUTC(this.state.availableDate).format("YYYY-MM-DD HH:mm:ss"),
        location_id: this.state.formLocationId || 0
      };
      await API.put(`/installerCalendarProgress/${this.state.newRequestId}`, calendarEntry);
    }

    addAppointment = async (appointment) => {
         let readAppt = `/readAppt/${appointment}`;        
         const { data: appt } = await API.get(readAppt);
     
     //    //console.log("Here's the data for the appointment :", appt);
     //    //console.log("description :", description);
        let calEntry = appt[0];
      //console.log("AddAppt : auth object : ", this.state.auth);
        let summary = `${calEntry.Year} ${calEntry.Make} ${calEntry.Model}`;
         let newAppt = {
             request : appointment,
             summary : summary,
             calendar : this.state.auth.calendar_id,
             description : "",
             startDate : calEntry.work_date,
             duration : calEntry.request_duration,
             installerId: this.props.typeId,
         };
         //console.log ("AddAppointment : Add to the calendar ", newAppt);
     
         let apptAdd = `/addAppt/`;
         await API.put(apptAdd, newAppt);
         return;
     };
    
addNote = async (newRequestId) => {
  if (!this.state.notes) {
    console.log("No notes to add, skipping...");
    return null;
  }

  let newNote = {
    requestId: newRequestId || this.state.newRequestId,
    noteDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    noteText: this.state.notes,
    userType: this.props.userType,
    userId: this.props.typeId
  }

  console.log("Adding note:", newNote);
  const { data: newRequestNote } = await API.post("/requestnotes/", newNote);
  return newRequestNote;
};

// UPDATED: Use shared pricing calculations for request creation
addRequest = async (pricingBreakdown, createAppointment = false) => {

  console.log("Tax debugging when adding the request:", {
  taxPercent: this.state.taxPercent,
  customerType: this.state.customerType,
  finalAmount: pricingBreakdown.finalAmount,
  calculatedTax: pricingBreakdown.taxes
});

  let newRequest = {
    requestType: this.props.userType,
    requestor: this.state.customer,
    serviceRequested: this.state.services[0].service_category + " - " + this.state.services[0].description,
    // All four header money fields, always, as numbers: the columns are NOT
    // NULL and the server maps these keys straight onto them (omitting them
    // failed every 9.0 create with ER_BAD_NULL_ERROR). The server re-derives
    // them from the lines posted right after this, so these are placeholders.
    requestTotal: pricingBreakdown.originalTotal,
    requestDiscount: pricingBreakdown.totalDiscount,
    requestFee: pricingBreakdown.platformFee,
    requestTaxes: pricingBreakdown.taxes,
    requestDuration: pricingBreakdown.totalDuration,   // Total duration
    assignedTo: this.props.typeId,
    createdBy: this.props.typeId,
    availableDate: dateService.toAPIDate(this.state.availableDate),
    dueDate: dateService.toAPIDate(this.state.availableDate),
    // Mobile bookings carry an appointment_start (date + time). Send as
    // ISO-8601 UTC with Z marker per the server's UTC-everywhere policy —
    // the moment object was constructed in the location's timezone so
    // .toISOString() converts to the correct UTC instant.
    appointment_start: this.state.appointmentStart
      ? moment(this.state.appointmentStart).toISOString()
      : null,
    currentState: "new",
    createdDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    vin: this.state.vehicle.vin,
    createdType : "installer",
    installerCatalog : this.props.typeId,
    location_id: this.state.referralLocationId || this.state.formLocationId,
    // Set only on the retry after the user confirmed "Create anyway". Tells the
    // server's DUP-GUARD to bypass its Layer-2 duplicate block. The 2-minute
    // idempotency collapse (Layer 1) still applies and still protects against
    // double-clicking the confirm button.
    ...(this._dupAcknowledged ? { allowDuplicate: true } : {})
  }

  // If this is a wholesale request entered by the installer
  if (this.state.customerType === "whole") {
    newRequest.requestType = "dealer";
    newRequest.currentState = "scheduled";
  }

  // If this is a retail walk-in being booked as an appointment, set as scheduled
  if (this.state.customerType !== "whole" && createAppointment) {
    newRequest.currentState = "scheduled";
  }

  // process the services requested array to create the right value
  if (this.state.services.length > 1) {
    newRequest.serviceRequested = newRequest.serviceRequested + " + " + (this.state.services.length-1);
  }

  const response = await API.post("/requestimates/", newRequest);
  console.log("addRequest API response:", response);
  console.log("addRequest API response.data:", response.data);

  // Extract the request ID from the response - handle various formats
  const newRequestId = response.data?.request_id || response.data?.requestId || response.data?.id || response.data;
  console.log("addRequest extracted newRequestId:", newRequestId);

  // Stop here rather than writing services, offers and calendar rows against an
  // id we do not have. Without this the id lands in a URL path
  // (PUT /installerCalendarProgress/undefined) and comes back as a bare 404
  // long after the orphan rows are already written.
  if (newRequestId === undefined || newRequestId === null || newRequestId === '' || typeof newRequestId === 'object') {
    throw new Error(
      `The server accepted the request but returned no usable request id ` +
      `(got ${JSON.stringify(response.data)}). Nothing further was saved.`
    );
  }

  this.setState({ newRequestId });
  return newRequestId;
}

// UPDATED: Use shared pricing calculations for services
addServices = async (requestId, pricingBreakdown) => {
  console.log("Services being saved:", this.state.services);
  console.log("Pricing breakdown:", pricingBreakdown);
  
  // Determine job type for submission
  const jobType = this.state.customerType === "whole" ? "dealer" : "retail";
  const taxRate = this.state.customerType === "whole" ? 0 : this.state.taxPercent;
  
  // Prepare services using shared pricing module
  const submissionData = SharedPricingUtils.prepareForSubmission(this.state.services, {
    jobType: jobType,
    taxRate: taxRate
  });
  
  const newRequestService = {
    requestId: await requestId,
    serviceId: "",
    // Inputs only — no serviceAmount / serviceValue / serviceFee. The server
    // derives them from unitPrice × serviceQuantity − serviceDiscount.
    serviceDiscount: 0,
    serviceDuration: 0,
    serviceState: "new",
    serviceDate: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    customDescription: "",
    retailPrice: 0,
    recommendedProductId: null,  // Product recommendation for technician
    serviceQuantity: 1,
    unitPrice: 0
  }

  for (let i = 0; i < submissionData.services.length; i++) {
    const service = submissionData.services[i];

    newRequestService.serviceId = service.service_id;
    newRequestService.serviceDiscount = service.service_discount; // Discount amount
    newRequestService.serviceDuration = service.service_duration; // Duration
    newRequestService.customDescription = service.custom_description || service.description;
    newRequestService.retailPrice = service.retail_price || null;
    newRequestService.recommendedProductId = service.recommended_product_id || null;
    newRequestService.serviceQuantity = service.quantity || 1;
    newRequestService.unitPrice = service.unit_price;
    // The kind comes from the line itself (pricing_kind), set when the service
    // was chosen from the catalog: 'unit' means quantity is a count and
    // duration scales with it; 'area' means quantity is a computed area and
    // duration does not scale.
    newRequestService.pricingKind = isAreaPriced(service) ? 'area' : 'unit';
    // The dimensions this line was PRICED with, and whether the estimator
    // typed the area rather than taking the computed one. They belong to the
    // LINE, not to the craft: a boat's reference data can change after the
    // fact — a corrected beam, a freeboard learned from a later job — and the
    // price already struck has to stay reproducible from the row that struck
    // it. It is also the only record of WHY a line is 4,856 sq ft.
    //
    // Without them the area calculator cannot reopen on a saved line: it has
    // the area but not the inputs, so it can re-confirm the price and never
    // recalculate it. Null on every non-marine line.
    newRequestService.marineVariables = service.marine_variables || null;
    newRequestService.marineAreaOverridden = service.marine_area_overridden ? 1 : 0;

    console.log(`Service ${i + 1}:`, {
      serviceId: service.service_id,
      description: service.description,
      serviceDiscount: service.service_discount,
      retailPrice: service.retail_price,
      quantity: service.quantity,
      unitPrice: service.unit_price
    });

    await API.post("/requestService", newRequestService);
  }
  return null;
}
 
addOffer = async (createAppointment = false, totalDuration = 1) => {
  // Determine the correct status - "scheduled" if booking appointment or dealer job, otherwise "offered"
  const offerStatus = (this.state.customerType === "whole" || createAppointment) ? "scheduled" : "offered";

  const jobDuration = parseInt(totalDuration) || 1;
  const calculatedEndDate = moment(this.state.availableDate).add(jobDuration - 1, 'days');

  const newRequestOffer = {
    requestId: this.state.newRequestId,
    installerId: this.props.typeId,
    currentStatus : offerStatus,
    dateUpdated: convertToUTC(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    startDate: dateService.toScheduledDateTime(
      this.state.availableDate,
      dateService.getTimeForDate(this.state.operatingHours, this.state.availableDate, 'open')
    ),
    endDate: dateService.toScheduledDateTime(
      calculatedEndDate,
      dateService.getTimeForDate(this.state.operatingHours, calculatedEndDate, 'close')
    ),
    location_id: this.state.formLocationId || 0
  }
console.log("Sending requestOffer with status:", offerStatus, newRequestOffer);

  await API.post("/requestoffered", newRequestOffer);
  return null;
};


  _next() {
    let currentStep = this.state.currentStep
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= 4 ? 5 : currentStep + 1
    this.setState({ currentStep: currentStep })
  }

  _prev() {
    let currentStep = this.state.currentStep
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1
    this.setState({ currentStep: currentStep })
  }

  // The "next" and "previous" button functions
  get previousButton() {

    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (<button className="jv-btn jv-btn-tertiary" type="button" onClick={this._prev}>Previous</button>)
    }

    // ...else return nothing
    return null;

  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 4, then render the "next" button
    if(currentStep < 5){
        let disable = true;
        if (currentStep === 1 && this.state.customer) {
          disable = false;
        }
        if (currentStep === 2 && this.checkVehicleComplete()) {
          disable = false;
        }
        if (currentStep === 3 && this.state.services.length > 0) {
          disable = false;
        }
        if (currentStep === 4) {
          disable = false;
        }
      return (
        <button
          className="jv-btn jv-btn-primary float-right"
          type="button" disabled={disable} onClick={this._next}>
        Next
        </button>        
      )
    } else {
      // ... must be the submit time...
      // Show same options for both dealer and retail customers:
      // Email estimate checkbox, Create Estimate button, Book Appointment button
      const needsLocation = isMultiLocation(this.props.locations) && !this.state.formLocationId;
      // Mobile bookings require an appointment slot before submit can fire.
      const needsAppointment = isMobileLocation(this.props.currentLocation) && !this.state.appointmentStart;
      const submitDisabled = this.state.loading || needsLocation || needsAppointment;
      return (
        <React.Fragment>
          <div className="d-flex align-items-center">
            <div className="form-check mr-3">
              <input
                type="checkbox"
                className="form-check-input"
                id="sendEstimate"
                checked={this.state.sendEstimate}
                onChange={(e) => this.setState({ sendEstimate: e.target.checked })}
              />
              <label className="form-check-label" htmlFor="sendEstimate">
                Email Estimate
              </label>
            </div>
            <button
              className="btn btn-outline-primary mr-2"
              type="button"
              onClick={(e) => this.handleSubmit(e, false)}
              disabled={submitDisabled}>
              {this.state.loading && <span>
                <i className="fa-sharp fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span>Create Estimate</span>}
            </button>
            <button
              className="jv-btn jv-btn-primary"
              type="button"
              onClick={(e) => this.handleSubmit(e, true)}
              disabled={submitDisabled}>
              {this.state.loading && <span>
                <i className="fa-sharp fa-solid fa-arrows-rotate fa-spin" />
              </span>}
              {!this.state.loading && <span><i className="fa-sharp fa-regular fa-calendar"></i> Book Appointment</span>}
            </button>
          </div>
        </React.Fragment>
      );
    }

  };

  get steepOne () {
    if (!this.state.customer) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Customer
            <div className="line-50-right"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Customer
          <div className="line-50-right"></div>
        </div>
      </li>
    );
  };
  get steepTwo () {
    if (!this.state.vehicle) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white">
            </button>
            <br />
            Vehicle
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Vehicle
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepThree () {
    if (this.state.services < 1) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Work
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Work
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFour () {
    if (!this.state.notes) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Notes
            <div className="line-100"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Notes
          <div className="line-100"></div>
        </div>
      </li>
    );
  };
  get steepFive () {
    if (this.state.currentStep !== 5 && this.state.dueDate) {
      return (
        <li className="nav-item">
          <div className="col-sm-12 p-0">
            <button className="btn btn-outline-secondary btn-circle bg-white"></button>
            <br />
            Dates
            <div className="line-50-left"></div>
          </div>
        </li>
      );
    }
    return (
      <li className="nav-item">
        <div className="col-sm-12 p-0">
          <button className="btn btn-outline-success btn-circle bg-white">
            <i className="fa-sharp fa-solid fa-check"></i>
          </button>
          <br />
          Dates
          <div className="line-50-left"></div>
        </div>
      </li>
    );
  };


  // This is also where when all the validation is completed, we push the new record
  // and redirect the page to the requestimate form with the parameters set
  render() {

    return (
      <React.Fragment>
        <DuplicateVinModal
          show={this.state.showDupModal}
          title="This vehicle already has another job"
          intro="This vehicle already has a job with this shop that hasn't been delivered or cancelled. Create another anyway?"
          confirmLabel="Create anyway"
          onConfirm={this.handleDupConfirm}
          onCancel={this.handleDupCancel}
        />
        <SaveDraftModal
          show={this.state.showSaveDraftModal}
          saving={this.state.savingDraft}
          onSaveDraft={this.handleSaveDraft}
          onDiscard={this.handleDiscardDraft}
          onKeepEditing={this.handleKeepEditing}
        />
        <div className="bg-white border border-secondary">
          <div className="col-lg-12 text-right">
            <button className="btn" type="button" onClick={this.handleCancel}>
              <i className="fa-sharp fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="col-lg-12 d-flex justify-content-center">
            <ul className="col-lg-5 nav nav-pills nav-fill text-center">
              {this.steepOne}
              {this.steepTwo}
              {this.steepThree}
              {this.steepFour}
              {this.steepFive}
            </ul>
          </div>
          <br />
          <br />
          <br />
          <div className="col-lg-12 p-0">
            <CustomerForm
                currentStep={this.state.currentStep}
                userType = "installer"
                vehicle={this.state.vehicle}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                dealerships = {this.state.dealerships}
                handleCustomer={this.handleCustomer}
                installer={this.state.installer}
                typeId={this.props.typeId}
                locationId={this.state.formLocationId || this.props.selectedLocationId}
                currentLocation={this.props.currentLocation}
                mode={"search"}
                customer={this.state.customer}
                customerName={this.state.customerName}
                customerEmail={this.state.customerEmail}
                customerType={this.state.customerType}
                />       
            <VehicleSelectForm
              currentStep={this.state.currentStep}
              handleVIN={this.handleVIN}
                onStockNumberChange={this.handleStockNumberChange}  // ADD THIS LINE
              /* A marine dealership always raises water work — which is a property
                 of the DEALERSHIP, not of which wizard the request is raised in.
                 So the installer's walk-in form types itself too when the selected
                 customer is a marine dealership, exactly as the dealer's own
                 wizard does. Retail customers are never typed: the estimator keeps
                 the Road/Water toggle.

                 Read off the selected dealer ROW, not isMarineDealer(): on an
                 installer scope companyAPI/dealerGroupAPI hold the INSTALLER's
                 data, so the cache lookup would answer 'auto' for every
                 dealership, silently. */
              forcedAssetType={
                this.state.customerType === "whole" && isMarineDealerRow(this.state.customerRow)
                  ? ASSET_TYPES.MARINE
                  : null
              }
              notes = {this.state.notes}
              default = {""}
              customer = {this.state.customer}
              installer = {this.state.installer}
              customerType= {this.state.customerType}
              userType={"installer"}
              vehicle={this.state.vehicle} />
            <ServiceForm
                userType={this.props.userType}
                typeId={this.props.typeId}
                currentStep={this.state.currentStep}
                handleServices={this.handleServices}
                total={this.state.total}
                customerType= {this.state.customerType}
                vehicle={this.state.vehicle}
                discount={this.state.discount}
                category={"Paint"}
                services={this.state.services}
                notes = {this.state.notes}
                serviceHint={this.state.serviceHint}
                duplicateRequestId={this.state.duplicateRequestId}
                currentLocation={this.props.currentLocation}/>
            <NotesForm 
                currentStep={this.state.currentStep} 
                vehicle={this.state.vehicle}
                userType = "installer"
                requestType = {this.state.customerType}
                availableDate = {this.state.availableDate}
                dueDate = {this.state.dueDate}
                services={this.state.services}
                notes = {this.state.notes}
                handleNotes={this.handleNotes}
                  onDealNumberChange={this.handleDealNumberChange}  // ADD THIS LINE
                />       
            {isMobileLocation(this.props.currentLocation) ? (
              <MobileAppointmentForm
                currentStep={this.state.currentStep}
                currentLocation={this.props.currentLocation}
                customerLat={
                  this.state.customerRow?.customer_address_lat
                  ?? this.state.customerRow?.latitude
                }
                customerLng={
                  this.state.customerRow?.customer_address_long
                  ?? this.state.customerRow?.longitude
                }
                services={this.state.services}
                appointmentStart={this.state.appointmentStart}
                onAppointmentChange={(dt) => this.setState({
                  appointmentStart: dt,
                  availableDate: dt ? moment(dt).startOf('day') : this.state.availableDate,
                  dueDate: dt ? moment(dt).startOf('day') : this.state.dueDate,
                })}
              />
            ) : (
              <DatesForm
                  userType={this.props.userType}
                  typeId={this.props.typeId}
                  selectedLocationId={this.props.selectedLocationId}
                  currentLocation={this.props.currentLocation}
                  currentStep={this.state.currentStep}
                  handleAvailableDate={this.handleAvailableDate}
                  availableDate={this.state.availableDate}
                  vehicle={this.state.vehicle}
                  services={this.state.services}
                  notes={this.state.notes}
                  discount={this.state.discount}
                  customer={this.state.customerName}
                  excludeDays={this.state.excludeDays}
              />
            )}

            {this.state.currentStep === 5 && isMultiLocation(this.props.locations) && !this.props.selectedLocationId && (
              <div className="text-center my-3 d-flex align-items-center justify-content-center">
                <label className="mb-0 mr-2 font-weight-bold">Location:</label>
                <LocationSelector
                  locations={this.props.locations}
                  selectedLocationId={this.state.formLocationId}
                  onChange={(locationId) => this.setState({ formLocationId: locationId })}
                  includeAll={false}
                />
              </div>
            )}

            <div className="m-5 d-flex justify-content-center">
              {/* <pre>{this.state.vehicle}</pre> */}
              <div className="p-2">
                {this.previousButton}
              </div>
              <div className="p-2">
                {this.nextButton}
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    );
  };

}
export default withRouter(WalkinForm);